import { Geometry, Program, Mesh, Texture } from 'ogl'
import vertex from './shaders/stars/vertex.glsl'
import fragment from './shaders/stars/fragment.glsl'
import particleMask from 'Images/particleMask.png'

export default class Stars {

  constructor({ gl, scene, count }) {
    this.count = count || 100
    this.gl = gl
    this.scene = scene

    //Methods
    this.createGeometry()
    this.createTexture()
    this.createProgram()
    this.createMesh()

  }


  createGeometry() {
    //
    this.positionArray = new Float32Array(this.count * 3)
    this.progressArray = new Float32Array(this.count)
    this.sizeArray = new Float32Array(this.count)
    this.alphaArray = new Float32Array(this.count)
    //
    for (let i = 0; i < this.count; i++) {
      this.positionArray.set([(Math.random() * 2 - 1), (Math.random() * 2 - 1), Math.random()], i * 3)
      this.progressArray.set([Math.random()], i)
      this.sizeArray.set([Math.random()], i)
      this.alphaArray.set([Math.random()], i)
      // this.position.set([(Math.random() * 2 - 1) * window.innerWidth / 2, (Math.random() * 2 - 1) * window.innerHeight / 2, Math.random()], i * 3)      
    }

    this.geometry = new Geometry(this.gl, {
      position: { size: 3, data: this.positionArray },
      aProgress: { size: 1, data: this.progressArray },
      aSize: { size: 1, data: this.sizeArray },
      aAlpha: { size: 1, data: this.alphaArray }
    })

  }

  createTexture() {
    //
    this.texture = new Texture(this.gl, {
      generateMipmaps: false,

    })
    //
    const image = new Image()
    image.src = particleMask
    image.crossOrigin = 'anonymous'
    image.onload = () => {
      this.texture.image = image
      // this.texture.width = image.naturalWidth
      // this.texture.height = image.naturalHeight
    }
  }

  createProgram() {
    this.program = new Program(this.gl, {
      vertex,
      fragment,
      uniforms: {
        uMask: { value: this.texture },
        uTime: { value: 0 },
        uColor: { value: "#FF0000" },
        uSize: { value: 25 },
        uResolution: { value: { width: window.innerWidth, height: window.innerHeight } }
      },
      transparent: true,
      depthTest: false,
      depthWrite: false
    })
  }

  createMesh() {
    this.mesh = new Mesh(this.gl, {
      mode: this.gl.POINTS,
      geometry: this.geometry,
      program: this.program
    })

    this.mesh.setParent(this.scene)
  }

  onResize(viewport) {
    this.viewport = viewport
    this.mesh.program.uniforms.uResolution.value = { width: viewport.width, height: viewport.height }
  }

  update(time) {
    this.mesh && (this.mesh.program.uniforms.uTime.value = time)
  }

}